import React, { createContext, ReactNode } from 'react';
import { useSystemConfigsQuery } from '../hooks/queries/useSystemConfigsQuery';
import { SystemConfig } from '../services/apiSLTP/systemConfig';

type SystemConfigContextType = {
    configs?: SystemConfig[] | null;
    isLoading: boolean;
    getConfigValue: (key: string) => any;
    getConfigsGroup: (key: string) => SystemConfig[] | undefined;
    refetch: () => void;
};

export const SystemConfigContext = createContext<SystemConfigContextType | null>(null);

interface SystemConfigProviderProps {
    children: ReactNode;
}

export const SystemConfigProvider: React.FC<SystemConfigProviderProps> = ({ children }) => {
    const { data: configs, isLoading, refetch } = useSystemConfigsQuery();

    const getConfigValue = (key: string): any => {
        return configs?.find((c) => c.key === key)?.value;
    };

    const getConfigsGroup = (group: string): SystemConfig[] | undefined => {
        return configs?.filter((c) => c.group === group);
    };

    return (
        <SystemConfigContext.Provider value={{ configs, isLoading, getConfigValue, getConfigsGroup, refetch }}>
            {children}
        </SystemConfigContext.Provider>
    );
};
